<template>
  <div>
    <b-navbar v-if="desktop || largeDesktop" toggleable="md" class="ctm py-4 px-4">
      <div class="sidebar-header">
        <transition>
          <button v-if="desktop || largeDesktop" type="button" @click="toggleMenu" id="sidebarCollapse" class="btn burger">
            <font-awesome-icon icon="bars"/>
          </button>
        </transition>
        <img src="../assets/logo.svg" class="logo"/>
        <h2>Fill-Bill</h2>
        <div class="vertslash">
          <h2>|</h2>
        </div>
        <h2 v-if="isEditedAsNewPackage()">Создать {{ packageType }}</h2>
        <h2 v-else>{{ $route.meta.name }} {{ packageId }}</h2>
      </div>
      <div v-if="this.isAbleToCreateDocuments.length > 0" @click="createPackage" class="ml-auto mr-5 create-package"><font-awesome-icon :icon="['fas', 'circle-plus']" class="mr-2" />Создать пакет</div>
      <b-navbar-nav :style="(this.isAbleToCreateDocuments.length === 0) ? 'margin-left: auto' : ''">
        <b-nav-item-dropdown right>
          <template #button-content>
            <font-awesome-icon class="mr-2" icon="user-circle"/>
            <span v-if="userInfo">{{ userInfo.name }}</span>
          </template>
          <b-dropdown-item @click="logout">Выход</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>

    <nav v-if="mobile || tablet" class="ctm d-flex align-items-center justify-content-between py-2 px-2">
      <div class="navbar-header d-flex align-items-center justify-content-between">
        <button type="button" v-b-toggle.sidebar-mobile class="btn burger">
          <font-awesome-icon icon="bars"/>
        </button>
        <img class="ml-3 mr-3" src="../assets/logo.svg"/>
        <h2 v-if="isEditedAsNewPackage() && tablet">Создать {{ packageType }}</h2>
        <h2 v-else-if="tablet">{{ $route.meta.name }} {{ packageId }}</h2>
      </div>
      <div v-if="this.isAbleToCreateDocuments.length > 0" @click="createPackage" class="ml-auto mr-5 create-package"><font-awesome-icon :icon="['fas', 'circle-plus']" class="mr-2" />Создать пакет</div>
      <b-dropdown size="md" variant="link" dropleft toggle-class="text-decoration-none" no-caret>
        <template v-slot:button-content>
          <font-awesome-icon icon="user-circle"/>
        </template>
        <b-dropdown-item v-if="userInfo">{{ userInfo.name }}</b-dropdown-item>
        <b-dropdown-divider v-if="userInfo"></b-dropdown-divider>
        <b-dropdown-item @click="logout">Выход</b-dropdown-item>
      </b-dropdown>
    </nav>
  </div>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  export default {
    name: 'main-header',
    data () {
      return {
         packageType: 'пакет'
      }
    },
    computed: {
      isAbleToCreateDocuments () {
        const splitedRights = this.userInfo.rights.user.map((item) => {
          return item.split('_')
        })
        let createRights = splitedRights.map((item) => {
          if (item[0] === "create") {
            return item.join('_')
          }
        })
        createRights = createRights.filter((item) => {
          return item !== undefined
        })
        return createRights
      },
      packageId () {
         switch (this.$route.name) {
           case 'EditCommissionShipment': 
             return '№' + this.$route.params.pid
           case 'EditHouseShipment':
             return '№' + this.$route.params.pid
           default: return ''
         }
      },
      ...mapState(
        {
          userInfo: state => state.authorization.userInfo,
          mobile: state => state.mobile,
          tablet: state => state.tablet,
          desktop: state => state.desktop,
          largeDesktop: state => state.largeDesktop,
          connection: state => state.socket.connection
        }
      )
    },
    watch: {},
    mounted () {},
    methods: {
      logout () {
        this.logOut()
          .then(
            () => {
              if (this.$route.name !== 'Login') {
                this.$router.push('/login')
              }
              this.connection.close()
            },
            (error) => {
              console.log(error)
            }
          )
      },
      isEditedAsNewPackage () {
        if (this.$route.name === 'EditCommissionShipment') this.packageType = 'Поручение на погрузку'
        else if (this.$route.name === 'EditHouseShipment') this.packageType = 'Товарную партию'
        return this.$route.query.new === 'true'
      },
      createPackage () {
        if (this.isAbleToCreateDocuments.length === 1) {
          switch (this.isAbleToCreateDocuments[0]) {
            case 'create_commissionshipment':
              this.$router.push({ name: 'AddNewCommissionShipment' })
              break
            case 'create_houseshipment':
              this.$router.push({ name: 'AddHouseShipment' })
              break
            default:
              break
          }
        } else {
          this.$router.push({ name: 'CreatePackageMaster' })
        }
      },
      ...mapActions({
        logOut: 'authorization/logout'
      }),
      ...mapMutations({
        toggleMenu: 'toggleMenu'
      })
    }
  }
</script>

<style lang="scss" scoped>
  .navbar.ctm {
    background: #ffffff;
    padding: 9px 13px;
    margin-bottom: 0;
    & .sidebar-header {
      display: flex;
      align-items: center;
      & h2 {
        margin-bottom: 0;
        color: #37474F;
        font-size: 25px;
        font-weight: 500;
        line-height: 28px;
      }
      .logo {
        margin: 0 16px;
      }
      .vertslash {
        display: block;
        margin: 0 15px 0 10px;
        position: relative;
        & h2 {
          position: absolute;
          top: -16px;
        }
      }
      .burger {
        background-color: #ffffff;
        &:focus {
          box-shadow: none;
        }
      }
      .section-title {
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
  .navbar-header {
    & h2 {
      margin-bottom: 0;
      color: #37474F;
      font-size: 25px;
      font-weight: 500;
      line-height: 28px;
    }
  }

  svg {
    color: #37474F;
  }

  .create-package {
    cursor: pointer;
    &:hover {
      color: #40b539 !important;
      -webkit-transition: all .5s;
      -moz-transition: all .5s;
      -o-transition: all .5s;
      transition: all .5s;
      & svg {
        color: #40b539;
        -webkit-transition: all .5s;
        -moz-transition: all .5s;
        -o-transition: all .5s;
        transition: all .5s;
      }
    }
  }

  @media screen and (max-width: 992px) {
    #sidebarCollapse span {
      display: none;
    }

    .sidebar-header h2 {
      font-size: 21px;
    }
  }
</style>
